import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MoneyService, SymbolService, TimeService } from '@easy-lib/modules/shared/services';
import { Store } from '@ngrx/store';
import { combineLatestWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { SettingStore } from '../setting/setting.store';
import * as portfolioSelector from './portfolio.selector';

@Injectable({
	providedIn: 'root'
})
export class PortfolioStore {
	store: Store = inject(Store);
	moneyService: MoneyService = inject(MoneyService);
	symbolService = inject(SymbolService);
	settingStore = inject(SettingStore);
	timeService = inject(TimeService);

	portfolioItems$ = this.store.select(portfolioSelector.getPortfolioItems);
	portfolioItems = toSignal(this.portfolioItems$);

	getPortfolioAllItems$ = this.store.select(portfolioSelector.getPortfolioAllItems);
	getPortfolioAllItems = toSignal(this.getPortfolioAllItems$);

	getPortfolioMarketData$ = this.store.select(portfolioSelector.getPortfolioMarketData);
	getPortfolioMarketData = toSignal(this.getPortfolioMarketData$);

	getLastPortfolioInsertTime$ = this.store.select(portfolioSelector.getLastPortfolioInsertTime);

	getPortfolioItemWitchCalculation$ = (symbolIsin: string) =>
		this.store.select(portfolioSelector.getPortfolioItemWithCalculation(symbolIsin));

	getPortfolioItemWitchCalculation = (symbolIsin: string) =>
		this.store.selectSignal(portfolioSelector.getPortfolioItemWithCalculation(symbolIsin));

	portfolioDPSItems$ = this.store.select(portfolioSelector.getPortfolioDPSListItems);

	portfolioExportExcelItems = this.store.selectSignal(portfolioSelector.getPortfolioItemsForExcel);

	portfolioItemTotalValues$ = this.moneyService.moneyInfo$.pipe(
		combineLatestWith(this.store.select(portfolioSelector.getPortfolioItemTotalValues)),
		map(([moneyInfo, portfolioItemTotals]) => {
			let _totalAssetValue = portfolioItemTotals.totalAssetsValue;
			if (moneyInfo.balance || moneyInfo.balance === 0) _totalAssetValue += moneyInfo.balance;
			if (moneyInfo.credit || moneyInfo.credit === 0) _totalAssetValue += +moneyInfo.credit;
			return { ...portfolioItemTotals, totalAssetsValue: _totalAssetValue };
		})
	);

	portfolioItemTotalValues = toSignal(this.portfolioItemTotalValues$);

	getPortfolioLoading$ = this.store.select(portfolioSelector.getPortfolioLoading);
	getPortfolioErrorState$ = this.store.select(portfolioSelector.getPortfolioErrorState);
}
